module.exports = __webpack_public_path__ + "img/monthly-sales.e2d52c41.svg";